export default __webpack_public_path__ + "static/media/accueilEntreprise.2da24f4f.jpg";